import RegistrationFlow from "@components/auth/RegistrationFlow";

export default function RegisterPage() {
  return (
    <div className="mx-auto flex size-full scroll-py-8 flex-col overflow-y-auto px-6 py-12 lg:w-[600px] lg:px-8">
      <div className="my-auto flex flex-col rounded-lg px-7 py-10 shadow-md sm:mx-auto sm:w-full sm:max-w-lg lg:bg-card lg:px-24">
        <img
          src="/orion-logo.svg"
          alt="ORION"
          className="mx-auto size-32 dark:invert"
        />

        <RegistrationFlow />
      </div>
    </div>
  );
}
